import { type FC } from 'react';

import { EmptyBalance } from '@/components/AdvertisePayments/components/Statuses/EmptyBalance';
import { ErrorModal } from '@/components/AdvertisePayments/components/Statuses/Error';
import { SuccessModal } from '@/components/AdvertisePayments/components/Statuses/Success';
import { SuccessTopUp } from '@/components/AdvertisePayments/components/Statuses/SuccessTopUp';
import { usePaymentModalsManager } from '@/components/AdvertisePayments/hooks/usePaymentModalsManager';
import { PAYMENT_MODAL_CY } from '@/constants/test-id';

import { UseModalControllerReturn } from '../../AdvertisePayments.types';

type RendererModalsProps = {
  modals: ReturnType<typeof usePaymentModalsManager>;
  activeCard: string;
  modalController?: UseModalControllerReturn;
  onRetry: () => void;
  onClose?: () => void;
  onAddBalance?: () => void;
};

export const RendererModals: FC<RendererModalsProps> = ({
  modals,
  activeCard,
  onRetry,
  onClose,
  onAddBalance
}) => {
  const modalsToRender = [
    modals.success.isOpen && (
      <SuccessModal
        key="success"
        activeCard={activeCard}
        onClose={() => {
          modals.success.close();
          onClose?.();
        }}
      />
    ),

    modals.errorTopUp.isOpen && (
      <ErrorModal
        key="error_top_up"
        title="Advertise.error_top_up_activation"
        description="Advertise.error_payment_desc"
        data-cy={PAYMENT_MODAL_CY.ERROR_TOP_UP_MODAL}
        onRetry={onRetry}
        onClose={() => {
          modals.errorTopUp.close();
          onClose?.();
        }}
      />
    ),

    modals.error.isOpen && (
      <ErrorModal
        key="error"
        title="Advertise.error_service_activation"
        description="Advertise.error_payment_desc"
        onRetry={onRetry}
        onClose={() => {
          modals.error.close();
          onClose?.();
        }}
      />
    ),

    modals.successTopUp.isOpen && (
      <SuccessTopUp
        key="success_top_up"
        onClose={() => {
          modals.successTopUp.close();
          onClose?.();
        }}
      />
    ),

    modals.emptyBalance.isOpen && (
      <EmptyBalance
        key="emptyBalance"
        onAddBalance={onAddBalance}
        onClose={modals.emptyBalance.close}
      />
    )
  ];

  return <>{modalsToRender.filter(Boolean)}</>;
};
